import { Icon, Typography } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Link, To } from 'react-router-dom';
import { atomsToHydrateAtom } from '@/atoms/hydration';
import { ConfigFilterSet } from '@/types/userConfigs';
import { getFilterAtomsToHydrate } from '@/utils/atoms/atomHydration';

export const FullscreenPreviewLink = ({ to, filtersToHydrate }: { to: To; filtersToHydrate: ConfigFilterSet }) => {
  const { t } = useTranslation('general');
  const setAtomsToHydrate = useSetAtom(atomsToHydrateAtom);

  return (
    <Link
      to={to}
      relative="route"
      className="absolute w-full h-full group z-10"
      onClick={() => setAtomsToHydrate(getFilterAtomsToHydrate(filtersToHydrate))}
    >
      <div className="absolute flex items-center gap-1 px-1 bg-canvas-secondary-main rounded-sb-full left-6 top-6 sm:opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-w-[calc(100%-48px)]">
        <Icon variant="EnterFullscreen" size="small" colour="primary" />
        <Typography as="span" variant="bodyMedium">
          {t('fullScreen')}
        </Typography>
      </div>
    </Link>
  );
};
